export type AngleEnum =
  | "front"
  | "side"
  | "back"
  | "3/4"
  | "top"
  | "sole"
  | "detail"
  | "other";

export const ANGLE_OPTIONS: AngleEnum[] = [
  "front",
  "side",
  "back",
  "3/4",
  "top",
  "sole",
  "detail",
  "other",
];

export const ANGLE_LABEL: Record<AngleEnum, string> = {
  front: "Front",
  side: "Side",
  back: "Back",
  "3/4": "3/4",
  top: "Top",
  sole: "Sole",
  detail: "Detail",
  other: "Other",
};

export interface ProductAngle {
  gallery_item_id: string | null;
  product_url: string;
  angle: AngleEnum | null;
}

// ─── Group Analyze ───────────────────────────────────────────────────────────

export interface GroupAnalyzeProductAngle {
  id: string;
  product_url: string;
  angle: string;
  angle_confidence: number;
}

export interface GroupVariants{
  id: string;
  name: string;
  products: GroupAnalyzeProductAngle[];
} 

export interface GroupAnalyzeProductAnalysis {
  summary: string;
  product_type: string;
  colors: string[];
  materials: string[];
  style_keywords: string[];
  hardware_finish: string;
}

export interface GroupAnalyzeProduct {
  id: string;
  name: string;
  sku_code: string;
  confidence: number;
  category: string;
  category_source: string;
  variants: GroupVariants[];
}

export interface GroupAnalyzeCategory {
  name: string;
  products: GroupAnalyzeProduct[];
}

export interface GroupAnalyzeResponseData {
  categories: GroupAnalyzeCategory[];
}

// ─── Service Payloads ─────────────────────────────────────────────────────────

export interface CreateProductSKUPayload {
  name: string;
  sku_code?: string | null;
  category?: string | null;
  description?: string | null;
  variants: ProductSKUResponse["variants"];
  analysis?: GroupAnalyzeProductAnalysis;
}

export interface UpdateProductSKUPayload {
  name?: string;
  sku_code?: string | null;
  category?: string | null;
  description?: string | null;
  variants?: ProductSKUResponse["variants"];
}

export interface BulkVariantItem {
  name: string;
  products: Array<{ url: string; angle?: AngleEnum | null }>;
}

export interface BulkProductSKUItem {
  name: string;
  sku_code?: string | null;
  category?: string | null;
  description?: string | null;
  variants: BulkVariantItem[];
  analysis?: GroupAnalyzeProductAnalysis;
}

export interface BulkCreateProductSKUPayload {
  items: BulkProductSKUItem[];
}

export interface GroupAnalyzePayload {
  image_urls: string[];
}

// ─────────────────────────────────────────────────────────────────────────────

export interface ProductResponse {
  gallery_item_id: string;
  product_url: string;
  angle: AngleEnum;
}

export interface ProductAnalysis {
  summary: string;
  product_type: string;
  use_cases: string[] | null;
  colors: string[];
  materials: string[];
  style_keywords: string[];
  hardware_finish: string | null;
  best_for: string[] | null;
}

export interface VariantResponse {
  id: string;
  name: string;
  products: ProductResponse[];
  analysis?: ProductAnalysis | null;
}

export interface ProductVariant {
  product_id: string;
  variant_id: string;
}

export interface ProductSKUResponse {
  id: string;
  name: string;
  sku_code: string | null;
  category: string | null;
  description: string | null;
  variants: VariantResponse[];
  created_by: string;
  created_at: string;
  updated_at: string;
  last_used_at: string | null;
}

export interface ProductSKUByCategoryResponse {
  id: string;
  name: string;
  product_url: string | null;
  created_at: string;
  updated_at: string;
  last_used_at: string | null;
}

export interface ProductSKUFilterResponse {
  id: string;
  name: string;
  category: string | null;
  product_url: string | null;
  created_at: string;
  updated_at: string;
  last_used_at: string | null;
}

export interface ProductSKUFilterRequest {
  categories?: string[] | null;
  skip: number;
  limit: number;
}
